export const allWorkspacesSelector = () => state => state.workspaces;
export const activeWorkspacesSelector = () => state => state.workspaces.filter(workspace => !workspace.disabled);
export const workspaceSelector = (key) => state => {
    if (!Boolean(key)) {
        return null;
    }

    return state.workspaces.find(t => t.pk === key);
};